import { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { billDataModel } from "./billDataModel";
import { useDetailModel } from "../detailModel";
import { BillResult } from "@/views/contract/manage/ContractManageTypes";
import { useGlobalModel } from "@/model/globalModel";

export function BillDataTable() {

    const { getDictNodeName } = useGlobalModel();
    const { loadLabel, dictLabels } = useDetailModel();

    const {
        loading, dataSource, pgCfg,
        loadData, setSelectedRowKeys,
    } = billDataModel();

    useEffect(() => {
        loadLabel();
    }, [])

    const columns: ColumnsType<BillResult> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '合约单号',
            dataIndex: 'contractCode',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '客户名称',
            dataIndex: 'partnerName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '支付类型',
            dataIndex: 'payType',
            align: "center",
            width: 100,
            ellipsis: true,
            render: t => dictLabels[t] ?? ''
        },
        {
            title: '账户类型',
            dataIndex: 'accountTypeName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '签约类型',
            dataIndex: 'contractType',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (text) => text === null || text === '' ? "暂无" : getDictNodeName(text)
        },
        {
            title: '分支',
            dataIndex: 'branch',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '单据类型',
            dataIndex: 'tradeTypeName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '账单编码',
            dataIndex: 'code',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '账户名称',
            dataIndex: 'accountName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '实体',
            dataIndex: 'beName',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '收支类型',
            dataIndex: 'ioFlag',
            align: "center",
            width: 100,
            ellipsis: true,
            render: t => t === 1 ? '收' : t === 2 ? '付' : ''
        },
        {
            title: '收款状态',
            dataIndex: 'status',
            align: "center",
            width: 100,
            ellipsis: true,
            render: t => t === 0 ? '初始' : t === 1 ? '已记账' : t === 2 ? '已核销' : ''
        },
        {
            title: '记账日期',
            dataIndex: 'createTime',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '核销人',
            dataIndex: 'writeoffUser',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '核销日期',
            dataIndex: 'writeoffTime',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '取消状态',
            dataIndex: 'cancelStatus',
            align: "center",
            width: 100,
            ellipsis: true,
            render: t => t === 0 ? '初始' : t === 1 ? '待审核' : t === 2 ? '审核通过' : t === 2 ? '驳回' : ''
        },

    ];

    useEffect(() => {
        loadData().then();
    }, [])

    return (
        <Table
            loading={loading}
            rowKey={record => record.key}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.key]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 446px)" }}
        />
    )
}

